import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getNotice, updateNotice } from "../../../api/homepageManagementHomeNotice.api";
import ErrorResponse from "../../../components/ErrorResponse";
import NoticeEditor from "../../../components/homepage/notice/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetNotice } from "../../../models/homepageManagementHomeNotice.model";

interface IMatch {
  campusCode: string;
  noticeCode: string;
}

const NoticeEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const campusCode = match.params.campusCode;
  const noticeCode = Number(match.params.noticeCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetNotice>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (campusCode && noticeCode) {
      execute(getNotice(campusCode, noticeCode));
    }
  }, [campusCode, noticeCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/homepage/notice${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!campusCode || !noticeCode) return;
    submitExecute(updateNotice(campusCode, noticeCode, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.notice.title4')}
      />
      <NoticeEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default NoticeEdit;
